import React, {Component} from "react"
import PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "../Typography"

import {EMOJI} from "./constants"
import {Title} from "./styled"

class PickerTitle extends Component {
  static propTypes = {
    titleValue: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }

  render() {
    const {titleValue, type} = this.props

    const message = type === EMOJI ? "platform.textarea.reactions.emoji" : "platform.textarea.reactions.companyValue"

    return (
      <Title>
        <Body small>
          <FormattedMessage id={message} values={{titleValue}} />
        </Body>
      </Title>
    )
  }
}

export default PickerTitle
